import { ApolloProvider } from "@apollo/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "next-themes";
import { I18nProvider } from "@lingui/react";

import { i18n } from "#i18n/utils";
import { apolloClient } from "src/api/graphql/apollo";
import { reactQueryClient } from "src/lib/clients";
import { store } from "src/redux/store";
import { StatsigReduxProvider } from "src/statsig/StatsigReduxProvider";
import CacheBusting from "#cache-busting";

/**
 * Global state providers for the RDB app.
 */
// only put _global_ providers here!
export function GlobalProviders({
    children,
}: {
    children: ReactNode | ReactNode[];
}) {
    const IS_DEV = process.env.NODE_ENV === "development";
    return (
        <ThemeProvider
            attribute="class"
            defaultTheme={IS_DEV ? "system" : "light"}
            enableSystem={IS_DEV}
        >
            <QueryClientProvider client={reactQueryClient}>
                <ApolloProvider client={apolloClient}>
                    <ReduxProvider store={store}>
                        <StatsigReduxProvider>
                            <I18nProvider i18n={i18n}>
                                <CacheBusting>{children}</CacheBusting>
                            </I18nProvider>
                        </StatsigReduxProvider>
                    </ReduxProvider>
                </ApolloProvider>
            </QueryClientProvider>
        </ThemeProvider>
    );
}
